module.exports = __webpack_public_path__ + "img/appBar.202608eb.png";